const checkFields = {
    checkField: {
        true: function(elem) {
            return $(elem).removeClass('has-value');
        },
        false: function(elem) {
            return $(elem).addClass('has-value');
        },
    },

    addFieldListeners() {
        $(document).on('focus', '.js-label__field', (e) => {
            const $fieldWrap = $(e.target).closest('.js-label');

            if ($fieldWrap.hasClass('has-focus')) return;

            $('.js-label').removeClass('has-focus');
            $($fieldWrap).addClass(['has-value', 'has-focus']);
        })
        .on('input', '.js-label__field', () => {
            const errorBlock = $(this).siblings('.label__error');

            $(this).closest('.js-label').removeClass('has-error');

            if (errorBlock.length <= 1) return $(errorBlock).remove();

            for (let i = 0; i < errorBlock.length; i++) {
                $(errorBlock[i]).remove();
            }
        })
        .on('blur', '.js-label__field', (e) => {
            const $fieldWrap = $(e.target).closest('.js-label');

            this.checkFillField($(e.target));

            $($fieldWrap).removeClass('has-focus');
        })
        .on('change', '.js-label__field', (e) => {
            const $fieldWrap = $(e.target).closest('.js-label');

            this.checkFillField($(e.target));

            $($fieldWrap).removeClass('has-focus');
        });
    },

    checkFillField(fields = $('.js-label__field')) {
        let $label = null;

        if (!fields.length) return;

        for (let i = 0; i < fields.length; i++) {
            $label = $(fields[i]).closest('.js-label');

            this.checkField[!$(fields[i]).val().length]($label);
        }
    },
};

export default checkFields;

$(() => {
    checkFields.checkFillField();
    checkFields.addFieldListeners();

    $('.js-label__field[autofocus]').closest('.js-label').addClass(['has-value', 'has-focus']);
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/field.js